
import { BrowserRouter, Route, Router, Routes } from 'react-router-dom';
import SettingsLayout from './layouts/SettingsLayout';
import DashboardPage from './components/admin-settigns/dashboard/DashboardPage';
import ThemePage from './components/admin-settigns/theme/ThemePage';
import NotificationPage from './components/admin-settigns/notification/NotificationPage';
import CategoryPage from './components/admin-settigns/category/CategoryPage';
import SubcategoryPage from './components/admin-settigns/subcategory/SubcategoryPage';
import InfoPage from './components/admin-settigns/info/InfoPage';
import QRCodePage from './components/admin-settigns/qr-code/QRCodePage';
import MenuItemsPage from './components/admin-settigns/menu-items/MenuItemsPage';
import LiveOrdersLayout from './layouts/LiveOrdersLayout';
import SuperAdminLayout from './layouts/SuperAdminLayout';
import { default as SADashboardPage } from './components/super-admin-settings/dashboard/DasboardPage';
import LocalsPage from './components/super-admin-settings/locals/LocalsPage';
import OwnersPage from './components/super-admin-settings/owners/OwnersPage';
import SettingsPage from './components/super-admin-settings/settings/SettingsPage';
import ClientMenuLayout from './layouts/ClientMenuLayout';
import LoginPage from './components/login/LoginPage';
import { AuthProvider } from './auth/AuthContext';
import { RequireUserType } from './auth/RequireUserType';
import { UserType } from './models/base/UserType';
import { NotificationProvider } from './components/toster-notification/NotificationContext';
import TosterNotification from './components/toster-notification/TosterNotification';
import SelectLocalPage from './components/admin-settigns/select-local/SelectLocalPage';
import ResetPasswordPage from './components/forgot-password/ResetPasswordPage';
import ForgotPasswordPage from './components/forgot-password/ForgotPasswordPage';
import SubscriptionPage from './components/super-admin-settings/subscription/SubscriptionPage';
import PlansPage from './components/super-admin-settings/plans/PlansPage';
import RegisterPage from './components/register/RegisterPage';
import ClientProfilePage from './components/client/client-profile/ClientProfilePage';
import LiveOrdersView1 from './components/live-orders/view1/LiveOrdersView1Page';
import TablesPage from './components/admin-settigns/tables/TablesPage';
import AfterRegisterVerifyEmailPage from './components/verify/AfterRegisterVerifyEmailPage';
import VerifyEmailPage from './components/verify/VerifyEmailPage';
import TablePositionPage from './components/live-orders/TablePositionPage';
import ClientPage from './components/client/main-page/ClientPage';
import OnlineClientPage from './components/client/online-menu/OnlineClientPage';
import IndexPage from './components/index/IndexPage';
import LiveOrdersView1FullScreenPage from './components/live-orders/view1-fullscreen/LiveOrdersView1FullScreenPage';
import LiveOrdersPickUpPage from './components/live-orders/pickup/LiveOrdersPickUpPage';
import LiveOrdersDineInPage from './components/live-orders/dinein/LiveOrdersDineInPage';
import LiveOrdersDeliveryPage from './components/live-orders/delivery/LiveOrdersDeliveryPage';
import OrderHistoryPage from './components/admin-settigns/orders-history/OrderHistoryPage';
import UsersPage from './components/super-admin-settings/users/UsersPage';
import UserReportsPage from './components/super-admin-settings/user-reports/UserReportsPage';
import WorkerSelectLocalPage from './components/worker-settings/select-local/WorkerSelectLocalPage';
import ReservationPage from './components/shared/reservation/ReservationPage';
import RestourantLinks from './components/client/retourant-links/page';
import CitiesSettingsPage from './components/super-admin-settings/city/page';
import LocationAreaSettingsPage from './components/super-admin-settings/location-area/page';
import TagPage from './components/super-admin-settings/tag/page';
import LocalEventPage from './components/admin-settigns/localEvent/page';
import { useEffect } from 'react';

function App() {

  useEffect(() => {

    if ("serviceWorker" in navigator) {

      navigator.serviceWorker
        .register("/notification-sw.js")
        .then(() => {
          console.log("Notification service worker registered.");
        })
        .catch(error => {
          console.error(
            "Service worker registration failed:",
            error
          );
        });
    }

  }, []);

  return (
    <BrowserRouter>
      <NotificationProvider>
        <AuthProvider>

          <TosterNotification />

          <Routes>

            <Route index element={<IndexPage />} />

            <Route element={<RequireUserType allowedRoles={[UserType.Admin, UserType.SuperAdmin]} />}>
              <Route path='select-local' element={<SelectLocalPage />} />
              <Route element={<SettingsLayout />}>
                <Route path="/settings/:localId" >
                  <Route path="dashboard" element={<DashboardPage />} />
                  <Route path="category" element={<CategoryPage />} />
                  <Route path="subcategory" element={<SubcategoryPage />} />
                  <Route path="menu-items" element={<MenuItemsPage />} />
                  <Route path="notification" element={<NotificationPage />} />
                  <Route path="local-events" element={<LocalEventPage />} />
                  <Route path="theme" element={<ThemePage />} />
                  <Route path="reservation" element={<ReservationPage />} />
                  <Route path="info" element={<InfoPage />} />
                  <Route path="qr-code" element={<QRCodePage />} />
                  <Route path="tables" element={<TablesPage />} />
                  <Route path="orders-history" element={<OrderHistoryPage />} />
                </Route>
              </Route>
            </Route>

            <Route element={<RequireUserType allowedRoles={[UserType.SuperAdmin]} />}>
              <Route element={<SuperAdminLayout />}>
                <Route path="/sa-settings">
                  <Route path="dashboard" element={<SADashboardPage />} />
                  <Route path="locals" element={<LocalsPage />} />
                  <Route path="owners" element={<OwnersPage />} />
                  <Route path="subscription" element={<SubscriptionPage />} />
                  <Route path="users" element={<UsersPage />} />
                  <Route path="user-reports" element={<UserReportsPage />} />
                  <Route path="plans" element={<PlansPage />} />
                  <Route path="settings" element={<SettingsPage />} />
                  <Route path="cities" element={<CitiesSettingsPage />} />
                  <Route path="location-areas" element={<LocationAreaSettingsPage />} />
                  <Route path="tags" element={<TagPage />} />
                </Route>
              </Route>
            </Route>

            <Route element={<RequireUserType allowedRoles={[UserType.Admin, UserType.LocalWorker]} />}>
              <Route element={<LiveOrdersLayout />}>
                <Route path="/live-orders/:localId" >
                  <Route path="view1" element={<LiveOrdersView1 />} />
                  <Route path="view1-fullscreen" element={<LiveOrdersView1FullScreenPage />} />
                  <Route path='dine-in' element={<LiveOrdersDineInPage />} />
                  <Route path='pickup' element={<LiveOrdersPickUpPage />} />
                  <Route path='delivery' element={<LiveOrdersDeliveryPage />} />
                  <Route path="reservation" element={<ReservationPage />} />
                  <Route path="tables-position/view1" element={<TablePositionPage />} />
                  {/* <Route path="tables-position/view1-fullscreen" element={< />} /> */}
                </Route>
              </Route>
            </Route>

            <Route element={<RequireUserType allowedRoles={[UserType.LocalWorker]} />}>
              <Route path="/worker-select-local" element={<WorkerSelectLocalPage />} />
            </Route>

            <Route element={<ClientMenuLayout />}>
              <Route path="/client-menu/:localId">
                <Route index element={<ClientPage />} />
                <Route path="online" element={<OnlineClientPage />} />
              </Route>
            </Route>

            <Route path=":slug/links" element={<RestourantLinks />} />

            <Route path="/client-profile" element={<ClientProfilePage />} />

            <Route path='/login' element={<LoginPage />} />
            <Route path='/register' element={<RegisterPage />} />
            <Route path='/after-register' element={<AfterRegisterVerifyEmailPage />} />

            <Route path='/verify-email' element={<VerifyEmailPage />} />

            <Route path="forgot-password" element={<ForgotPasswordPage />} />
            <Route path="reset-password" element={<ResetPasswordPage />} />

            {/* <Route path="/test-settings/panel" element={
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '20px' }}>
                <a href="/live-orders/8335be5e-ea0e-4247-9517-7dc936274d29/view1">Go to Live Orders</a>
                <a href="/live-orders-temp">Go to Live Orders Temp</a>
                <a href="/sa-settings/dashboard">Go to Super Admin Dashboard</a>
                <a href="/settings/dashboard">Go to Settings Dashboard</a>
                <a href="/client-menu/8335be5e-ea0e-4247-9517-7dc936274d29">Go to Client Menu</a>
                <a href="/client-menu/8335be5e-ea0e-4247-9517-7dc936274d29?tableId=ffe7b62c-bc7f-4011-b80a-01109f2f2de2">Go to Client Menu on table 1</a>
                <a href="/client-menu/8335be5e-ea0e-4247-9517-7dc936274d29/online">Go to Client Menu Online</a>
                <a href="/select-local">Go to Select Local</a>
                <a href="/client-profile">Go to Client Profile</a>
                <a href="/login">Go to Login</a>
                <a href="/register">Go to Register</a>
                <a href="/after-register">Go to After Register Verify Email</a>
              </div>
            } /> */}

          </Routes>
        </AuthProvider>
      </NotificationProvider>
    </BrowserRouter>
  );
}

export default App;
